import { baseApi, TAG } from '../../app/api/baseApi'
const configurationTag = (connectorId, instanceId) => ({ type: TAG.CONFIGURATION, id: `${connectorId}|${instanceId}` })
const asItems = (data) => (Array.isArray(data) ? data : [])
export const configurationsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getConfigurations: builder.query({
            query: ({ connectorId, instanceId }) => `/Client/connection/${connectorId}/instance/${instanceId}/configurations`,
            transformResponse: (data) => ({
                source: asItems(data && data.source),
                target: asItems(data && data.target)
            }),
            providesTags: (result, error, { connectorId, instanceId }) => [configurationTag(connectorId, instanceId)]
        }),
        updateConfiguration: builder.mutation({
            query: ({ instanceId, sourceEndpointId, targetEndpointId, item }) => ({
                url: `/Client/${sourceEndpointId}/endpointId/${targetEndpointId}/subInstanceId/${instanceId}`,
                method: 'PUT',
                body: [{
                    id: item.id,
                    key: item.key,
                    values: item.values,
                    isVisible: item.isVisible,
                    endpointName: item.endpointName,
                    type: item.type
                }]
            }),
            invalidatesTags: (result, error, { connectorId, instanceId }) =>
                (result === true ? [configurationTag(connectorId, instanceId)] : [])
        })
    })
})

export const { useGetConfigurationsQuery, useUpdateConfigurationMutation } = configurationsApi
